import { AsButton, AsNumber, IconClose } from '@adserve/adserve-react-components';
import React, { useContext, useState, useRef, useEffect } from 'react';
import { SystemSettingsContext } from '../../../../contexts/SystemSettingsContext';
import WeeklyBudgetTable from './WeeklyBudgetTable';

const WeeklyBudgetDropdownTongue = ({
    id,
    weeklyBudget,
    weeklyBudgets,
    totalBudget,
    onApplyChanges,
    onBudgetChange,
    onClose,
    //changeMade = false,
    disabled = false,
    generateBudgetsArray
}) => {
    const { formatCurrency } = useContext(SystemSettingsContext);
    const ref = useRef(null);

    const labelStyle = {
        fontSize: 14,
        fontWeight: 500
    };

    const [weeklyBudgetLocal, setWeeklyBudgetLocal] = useState(weeklyBudget);
    const [weeklyBudgetsLocal, setWeeklyBudgetsLocal] = useState(weeklyBudgets);
    const [totalBudgetLocal, setTotalBudgetLocal] = useState(totalBudget);
    const [changeMade, setChangeMade] = useState(false);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                onClose();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref]);

    const handleBudgetChange = (event) => {
        let temp = [ ...weeklyBudgetsLocal];

        if (!temp || temp.length === 0) {
            temp = generateBudgetsArray();
        }

        let total = 0;
        for (let index = 0; index <= temp.length - 1; index++) {
            temp[index].value = event.target.value;
            total += parseFloat(event.target.value);
        }

        setWeeklyBudgetLocal(event.target.value);
        setWeeklyBudgetsLocal(temp);
        setTotalBudgetLocal(total);
        setChangeMade(true);
    };

    const handleApplyChanges = () => {
        onClose();
        typeof onApplyChanges === 'function' && onApplyChanges(weeklyBudgetsLocal);
    };

    const handleWeekBudgetChange = (data) => {
        const changes = [...weeklyBudgetsLocal];

        const week = changes.find((c) => c.key === data.key);

        if (week) {
            week.value = parseFloat(data.value);
            if (isNaN(week.value)) week.value = 0;

            week.value = week.value.toString();
        }

        const totalBudget = changes.reduce((a, b) => {
            return a + parseFloat(b.value);
        }, 0);

        if (totalBudget !== totalBudgetLocal) {
            setTotalBudgetLocal(totalBudget);
        }

        setWeeklyBudgetsLocal(changes);
        setWeeklyBudgetLocal('-');
        setChangeMade(true);
    };

    return (
        <div
            ref={ref}
            style={{
                display: 'flex',
                flexDirection: 'column',
                position: 'absolute',
                border: '1px solid #CCCCCC',
                borderRadius: '0 0 15px 15px',
                backgroundColor: '#FFFFFF',
                width: 400,
                boxSizing: 'border-box',
                padding: '10px 10px 20px 10px',
                marginTop: -1,
                marginLeft: 22,
                zIndex: 2
            }}
        >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontWeight: 500 }}>{window.translate('Weekly Budget')}</span>
                <AsNumber
                    id={`${id}-tongue`}
                    name={id}
                    labelStyle={labelStyle}
                    inputStyle={{
                        width: 200,
                        height: 41,
                        boxSizing: 'border-box',
                        fontWeight: 600,
                        fontSize: 15,
                        outline: 'none',
                        autoComplete: 'off'
                    }}
                    value={weeklyBudgetLocal}
                    onChange={handleBudgetChange}
                    disallowNegatives={true}
                    disabled={disabled}
                    allowFloat={true}
                    formatCurrency={formatCurrency}
                />
                <IconClose
                    id='scriptFactorsClose'
                    size={15}
                    onClick={onClose}
                />
            </div>

            <WeeklyBudgetTable
                budgetData={weeklyBudgetsLocal}
                totalBudget={totalBudgetLocal}
                onChange={handleWeekBudgetChange}
                readOnly={disabled}
                style={{ width: 350, marginTop: 20 }}
            />

            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <AsButton
                    style={{
                        height: 34,
                        width: '37%',
                        fontSize: 15,
                        fontWeight: 500,
                        marginTop: 20
                    }}
                    disabled={disabled || !changeMade}
                    handleClick={handleApplyChanges}
                >
                    {window.translate('Apply')}
                </AsButton>
            </div>
        </div>
    );
};

export default WeeklyBudgetDropdownTongue;
